import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=257dd020&scoped=true&lang=pug&"
import script from "./infos.vue?vue&type=script&lang=ts&"
export * from "./infos.vue?vue&type=script&lang=ts&"
import style0 from "./infos.vue?vue&type=style&index=0&id=257dd020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257dd020",
  null
  
)

export default component.exports